import React from "react";
import { Card } from "semantic-ui-react";
import RedTag from "../../../components/Products/components/RedTag/RedTag";
const MovilImgs = (props) => {
  const { selectorImage, setSelectorImage, productDetail } = props;
  return (
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        width: "100%",
      }}
    >
      <div
        style={{
          width: "100%",
        }}
      >
        <Card
          className="card-selected"
          style={{
            backgroundImage: `url(${
              productDetail.data !== undefined &&
              productDetail.data.images.length > 0
                ? JSON.parse(productDetail.data.images[selectorImage]).url
                : null
            })`,
            display: "flex",
            backgroundSize: "cover",
            objectFit: "cover",
            backgroundPosition: "center",
            height: 400,
            width: "100%",
          }}
        >
          {productDetail.data && !productDetail.data.available ? (
            <RedTag message="Agotado" />
          ) : null}
        </Card>
        <Card.Group
          itemsPerRow={
            productDetail.data !== undefined &&
            productDetail.data.images.length > 1
              ? productDetail.data.images.length
              : 2
          }
        >
          {productDetail.data !== undefined &&
            productDetail.data.images.map((productImage, index) => (
              <Card
                color={selectorImage === index ? "red" : "grey"}
                key={index}
                onClick={() => setSelectorImage(index)}
                style={{
                  backgroundImage: `url(${JSON.parse(productImage).url})`,
                  display: "flex",
                  backgroundSize: "cover",
                  height: 150,
                  zIndex: "auto",
                }}
              />
            ))}
        </Card.Group>
      </div>
    </div>
  );
};

export default MovilImgs;
